import { render } from "./NewInventoryModal.vue?vue&type=template&id=59138c8a&scoped=true"
import script from "./NewInventoryModal.vue?vue&type=script&lang=js"
export * from "./NewInventoryModal.vue?vue&type=script&lang=js"

import "./NewInventoryModal.vue?vue&type=style&index=0&id=59138c8a&scoped=true&lang=css"

import exportComponent from "/var/www/TheIdFactory/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59138c8a"]])

export default __exports__